import AddToCartModal from './AddToCartModal';

export default AddToCartModal;



// WEBPACK FOOTER //
// ./src/components/shared/AddToCartModal/index.jsx